export default __webpack_public_path__ + "static/media/escrow_500.4ef9fb1c.svg";